<template>
  <v-pagination
    v-bind="$attrs"
    v-on="$listeners"
    next-icon="keyboard_arrow_right"
    prev-icon="keyboard_arrow_left"
    :value="value"
  ></v-pagination>
</template>

<script>
export default {
  name: "BasePagination",
  props: {
    value: {
      type: Number,
      required: true
    }
  }
};
</script>

<style></style>
